import { render, staticRenderFns } from "./EstimationPrice.vue?vue&type=template&id=ffa670ba&scoped=true&"
import script from "./EstimationPrice.vue?vue&type=script&lang=js&"
export * from "./EstimationPrice.vue?vue&type=script&lang=js&"
import style0 from "./EstimationPrice.vue?vue&type=style&index=0&id=ffa670ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa670ba",
  null
  
)

export default component.exports